require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("@tinacms/react-core"), require("@tinacms/fields"), require("@tinacms/styles"), require("@tinacms/react-screens"), require("styled-components"), require("@tinacms/react-modals"), require("@tinacms/form-builder"), require("@tinacms/forms"), require("@tinacms/icons"), require("react-dismissible"), require("@tinacms/react-forms")) : "function" == typeof define && define.amd ? define(["exports", "react", "@tinacms/react-core", "@tinacms/fields", "@tinacms/styles", "@tinacms/react-screens", "styled-components", "@tinacms/react-modals", "@tinacms/form-builder", "@tinacms/forms", "@tinacms/icons", "react-dismissible", "@tinacms/react-forms"], e) : e((n = n || self)["@tinacms/react-toolbar"] = {}, n.React, n.reactCore, n.fields, n.styles, n.reactScreens, n.styled, n.reactModals, n.formBuilder, n.forms, n.icons, n.reactDismissible, n.reactForms);
}(this, function (n, k, E, t, r, C, e, o, l, s, z, d, I) {
  "use strict";

  function i(n) {
    var e, t;
    void 0 === n && (n = {}), this.buttons = {
      save: "Save",
      reset: "Reset"
    }, (null === (e = n.buttons) || void 0 === e ? void 0 : e.save) && (this.buttons.save = n.buttons.save), (null === (t = n.buttons) || void 0 === t ? void 0 : t.reset) && (this.buttons.reset = n.buttons.reset);
  }

  var a = "default" in e ? e["default"] : e,
      _S = function S() {
    return (_S = Object.assign || function (n) {
      for (var e, t = 1, i = arguments.length; t < i; t++) {
        for (var a in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function c(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  function N() {
    var n = E.useCMS(),
        e = k.useState(!1),
        t = e[0],
        i = e[1],
        a = n.plugins.findOrCreateMap("content-creator");
    return E.useSubscribable(a), a.all().length ? k.createElement($, null, k.createElement(nn, {
      onClick: function onClick() {
        return i(!0);
      },
      open: t
    }, k.createElement(z.AddIcon, null), " ", k.createElement(X, null, "New")), k.createElement(en, {
      open: t
    }, k.createElement(d.Dismissible, {
      click: !0,
      escape: !0,
      onDismiss: function onDismiss() {
        return i(!1);
      },
      disabled: !t
    }, a.all().map(function (n) {
      return k.createElement(Y, {
        plugin: n,
        key: n.name,
        onClick: function onClick() {
          i(!1);
        }
      });
    })))) : null;
  }

  function M(n) {
    var t = n.form,
        e = k.useState(!1),
        i = e[0],
        a = e[1];
    return k.createElement(k.Fragment, null, k.createElement(rn, {
      open: i,
      onClick: function onClick() {
        return a(function (n) {
          return !n;
        });
      }
    }), k.createElement(on, {
      open: i
    }, k.createElement(d.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !i,
      allowClickPropagation: !0,
      onDismiss: function onDismiss() {
        a(function (n) {
          return !n;
        });
      }
    }, (null == t ? void 0 : t.actions) && t.actions.map(function (n, e) {
      return k.createElement(n, {
        form: t,
        key: e
      });
    }), k.createElement(sn, null))));
  }

  var p,
      g,
      m,
      u,
      f,
      h,
      b,
      v,
      x,
      y,
      w,
      j,
      B,
      O,
      q,
      T,
      P,
      F,
      A,
      D,
      L,
      _,
      R,
      W,
      H,
      K,
      U,
      V,
      G,
      J,
      Q,
      X = a.span.withConfig({
    displayName: "DesktopLabel",
    componentId: "sc-1mp7aab"
  })(p = p || c(["\n  display: none;\n  @media (min-width: 1030px) {\n    display: inline;\n  }\n"], ["\n  display: none;\n  @media (min-width: 1030px) {\n    display: inline;\n  }\n"])),
      Y = function Y(n) {
    var e = n.plugin,
        t = n.onClick,
        i = k.useState(!1),
        a = i[0],
        r = i[1];
    return k.createElement(k.Fragment, null, k.createElement(tn, {
      onClick: function onClick() {
        r(function (n) {
          return !n;
        }), t();
      }
    }, e.name), a && k.createElement(Z, {
      plugin: e,
      close: function close() {
        return r(!1);
      }
    }));
  },
      Z = function Z(n) {
    var t = n.plugin,
        i = n.close,
        e = E.useCMS(),
        a = k.useMemo(function () {
      return new s.Form({
        label: "create-form",
        id: "create-form-id",
        actions: [],
        fields: t.fields,
        onSubmit: function onSubmit(n) {
          t.onSubmit(n, e).then(function () {
            i();
          });
        }
      });
    }, [i, e, t]);
    return k.createElement(o.Modal, null, k.createElement(l.FormBuilder, {
      form: a
    }, function (n) {
      var e = n.handleSubmit;
      return k.createElement(o.ModalPopup, null, k.createElement(o.ModalHeader, {
        close: i
      }, t.name), k.createElement(o.ModalBody, {
        onKeyPress: function onKeyPress(n) {
          return 13 === n.charCode ? e() : null;
        }
      }, k.createElement(l.FieldsBuilder, {
        form: a,
        fields: a.fields
      })), k.createElement(o.ModalActions, null, k.createElement(r.Button, {
        onClick: i
      }, "Cancel"), k.createElement(r.Button, {
        onClick: e,
        primary: !0
      }, "Create")));
    }));
  },
      $ = a.div.withConfig({
    displayName: "ContentMenuWrapper",
    componentId: "sc-1vrv1yt"
  })(g = g || c(["\n  position: relative;\n  grid-area: actions;\n  justify-self: end;\n"], ["\n  position: relative;\n  grid-area: actions;\n  justify-self: end;\n"])),
      nn = a(r.Button).withConfig({
    displayName: "CreateToggleButton",
    componentId: "sc-4p4ehl"
  })(u = u || c(["\n  display: flex;\n  align-items: center;\n  transition: all 150ms ease-out;\n  padding: 0 10px;\n\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n  }\n\n  &:focus {\n    outline: none !important;\n  }\n\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2em;\n    height: 2em;\n    margin-right: 0.25rem;\n    transform-origin: 50% 50%;\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  transition: all 150ms ease-out;\n  padding: 0 10px;\n\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n  }\n\n  &:focus {\n    outline: none !important;\n  }\n\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2em;\n    height: 2em;\n    margin-right: 0.25rem;\n    transform-origin: 50% 50%;\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"]), function (n) {
    return n.open && e.css(m = m || c(["\n      background-color: transparent;\n\n      svg {\n        transform: rotate(45deg);\n      }\n    "], ["\n      background-color: transparent;\n\n      svg {\n        transform: rotate(45deg);\n      }\n    "]));
  }),
      en = a.div.withConfig({
    displayName: "ContentMenu",
    componentId: "sc-17c3uq5"
  })(h = h || c(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid var(--tina-color-grey-2);\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n\n  ", ";\n"]), function (n) {
    return n.open && e.css(f = f || c(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 44px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      tn = a.button.withConfig({
    displayName: "CreateButton",
    componentId: "sc-nqchy"
  })(b = b || c(["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 40px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-1);\n  padding: 0 12px;\n  height: 40px;\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: #f6f6f9;\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"])),
      an = a(r.Button).withConfig({
    displayName: "ToolbarButton",
    componentId: "sc-la7n8z"
  })(v = v || c(["\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: 0 10px;\n\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2.5em;\n    height: 2.5em;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    filter: grayscale(25%);\n  }\n\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n\n    svg {\n      margin-right: 0.25rem;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  padding: 0 10px;\n\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    fill: currentColor;\n    opacity: 0.7;\n    width: 2.5em;\n    height: 2.5em;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    filter: grayscale(25%);\n  }\n\n  @media (min-width: 1030px) {\n    padding: 0 20px;\n\n    svg {\n      margin-right: 0.25rem;\n    }\n  }\n"])),
      rn = a(function (n) {
    return k.createElement("button", _S({}, n), k.createElement(z.EllipsisVerticalIcon, null));
  }).withConfig({
    displayName: "MoreActionsButton",
    componentId: "sc-qrp5ap"
  })(y = y || c(["\n  height: var(--tina-toolbar-height);\n  width: 36px;\n  align-self: stretch;\n  background-color: white;\n  background-position: center;\n  background-size: auto 18px;\n  background-repeat: no-repeat;\n  border: 0;\n  margin: 0 -12px 0 12px;\n  outline: none;\n  cursor: pointer;\n  transition: all 150ms ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: 1px solid var(--tina-color-grey-2);\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    svg {\n      fill: var(--tina-color-primary);\n    }\n  }\n  svg {\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"], ["\n  height: var(--tina-toolbar-height);\n  width: 36px;\n  align-self: stretch;\n  background-color: white;\n  background-position: center;\n  background-size: auto 18px;\n  background-repeat: no-repeat;\n  border: 0;\n  margin: 0 -12px 0 12px;\n  outline: none;\n  cursor: pointer;\n  transition: all 150ms ease-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: 1px solid var(--tina-color-grey-2);\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    svg {\n      fill: var(--tina-color-primary);\n    }\n  }\n  svg {\n    transition: all 150ms ease-out;\n  }\n\n  ", ";\n"]), function (n) {
    return n.open && e.css(x = x || c(["\n      background-color: var(--tina-color-grey-1);\n      box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.06);\n      svg {\n        fill: var(--tina-color-primary);\n      }\n      &:hover {\n        svg {\n          fill: var(--tina-color-primary);\n        }\n      }\n    "], ["\n      background-color: var(--tina-color-grey-1);\n      box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.06);\n      svg {\n        fill: var(--tina-color-primary);\n      }\n      &:hover {\n        svg {\n          fill: var(--tina-color-primary);\n        }\n      }\n    "]));
  }),
      on = a.div.withConfig({
    displayName: "ActionsOverlay",
    componentId: "sc-1if3bc1"
  })(j = j || c(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 14px;\n  transform: translate3d(0, 23px, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0%;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 14px;\n  transform: translate3d(0, 23px, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0%;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", ";\n"]), function (n) {
    return n.open && e.css(w = w || c(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 55px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 55px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      ln = a(I.ActionButton).withConfig({
    displayName: "ExitButton",
    componentId: "sc-kalus"
  })(B = B || c(["\n  height: 32px;\n  background-color: var(--tina-color-grey-1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:not(:first-child) {\n    border-top: 2px solid var(--tina-color-grey-2);\n  }\n\n  svg {\n    fill: currentColor;\n    width: 24px;\n    margin-right: 2px;\n  }\n"], ["\n  height: 32px;\n  background-color: var(--tina-color-grey-1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:not(:first-child) {\n    border-top: 2px solid var(--tina-color-grey-2);\n  }\n\n  svg {\n    fill: currentColor;\n    width: 24px;\n    margin-right: 2px;\n  }\n"])),
      sn = function sn() {
    var n = E.useCMS();
    return k.createElement(ln, {
      onClick: function onClick() {
        n.disable();
      }
    }, k.createElement(z.ExitIcon, null), " Exit Tina");
  },
      dn = function dn(n) {
    var e = n.dirty;
    return k.createElement(t.FieldMeta, {
      name: "Form Status",
      margin: !1
    }, e ? k.createElement(xn, null, k.createElement(vn, {
      warning: !0
    }), " ", k.createElement(X, null, "Unsaved changes")) : k.createElement(xn, null, k.createElement(vn, null), " ", k.createElement(X, null, "No changes")));
  },
      cn = a.div.withConfig({
    displayName: "StyledToolbar",
    componentId: "sc-1k9nag4"
  })(O = O || c(["\n  ", "\n\n  font-family: 'Inter', sans-serif;\n  position: fixed;\n  top: 0;\n  left: ", ";\n  right: 0;\n  padding: 0 12px;\n  height: 62px;\n  z-index: var(--tina-z-index-3);\n  box-sizing: border-box;\n  display: grid;\n  grid-template-areas: 'left right';\n  grid-template-columns: auto 1fr;\n  align-items: stretch;\n  background-color: var(--tina-color-grey-1);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  border-bottom: 1px solid var(--tina-color-grey-2);\n  transition: left var(--tina-timing-long) ease-out;\n\n  @media (max-width: 1029px) {\n    label {\n      display: none;\n    }\n  }\n"], ["\n  ", "\n\n  font-family: 'Inter', sans-serif;\n  position: fixed;\n  top: 0;\n  left: ", ";\n  right: 0;\n  padding: 0 12px;\n  height: 62px;\n  z-index: var(--tina-z-index-3);\n  box-sizing: border-box;\n  display: grid;\n  grid-template-areas: 'left right';\n  grid-template-columns: auto 1fr;\n  align-items: stretch;\n  background-color: var(--tina-color-grey-1);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  border-bottom: 1px solid var(--tina-color-grey-2);\n  transition: left var(--tina-timing-long) ease-out;\n\n  @media (max-width: 1029px) {\n    label {\n      display: none;\n    }\n  }\n"]), r.tina_reset_styles, function (n) {
    return n.menuIsOpen ? "var(--tina-sidebar-width)" : "0";
  }),
      pn = a(an).withConfig({
    displayName: "SaveButton",
    componentId: "sc-89b9is"
  })(q = q || c(["\n  padding: 0 32px;\n"], ["\n  padding: 0 32px;\n"])),
      gn = a.div.withConfig({
    displayName: "WidgetsContainer",
    componentId: "sc-1ij1icy"
  })(T = T || c(["\n  grid-area: widgets;\n  display: flex;\n  align-self: stretch;\n  align-items: center;\n  justify-self: end;\n  padding-right: 12px;\n  border-right: 1px solid white;\n  box-shadow: inset -1px 0 0 #e1ddec;\n  background-image: linear-gradient(\n    to left,\n    rgba(0, 0, 0, 0.01),\n    transparent 48px\n  );\n\n  > * {\n    margin-bottom: 0;\n    margin-left: 16px;\n  }\n\n  label {\n    margin-bottom: 0;\n    white-space: nowrap;\n  }\n\n  @media (min-width: 1030px) {\n    > div {\n      display: block;\n    }\n  }\n"], ["\n  grid-area: widgets;\n  display: flex;\n  align-self: stretch;\n  align-items: center;\n  justify-self: end;\n  padding-right: 12px;\n  border-right: 1px solid white;\n  box-shadow: inset -1px 0 0 #e1ddec;\n  background-image: linear-gradient(\n    to left,\n    rgba(0, 0, 0, 0.01),\n    transparent 48px\n  );\n\n  > * {\n    margin-bottom: 0;\n    margin-left: 16px;\n  }\n\n  label {\n    margin-bottom: 0;\n    white-space: nowrap;\n  }\n\n  @media (min-width: 1030px) {\n    > div {\n      display: block;\n    }\n  }\n"])),
      mn = a.div.withConfig({
    displayName: "AlignLeft",
    componentId: "sc-1x2on71"
  })(P = P || c(["\n  grid-area: left;\n  justify-self: start;\n  display: flex;\n  align-items: center;\n"], ["\n  grid-area: left;\n  justify-self: start;\n  display: flex;\n  align-items: center;\n"])),
      un = a.div.withConfig({
    displayName: "AlignRight",
    componentId: "sc-pk90ep"
  })(F = F || c(["\n  grid-area: right;\n  justify-self: end;\n  display: flex;\n  align-items: center;\n"], ["\n  grid-area: right;\n  justify-self: end;\n  display: flex;\n  align-items: center;\n"])),
      fn = a.div.withConfig({
    displayName: "Status",
    componentId: "sc-1ff6qj1"
  })(A = A || c(["\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-bottom: 0;\n    margin-left: 1rem;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-bottom: 0;\n    margin-left: 1rem;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n"])),
      hn = a.div.withConfig({
    displayName: "Actions",
    componentId: "sc-9yugsx"
  })(D = D || c(["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    margin-left: 12px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    margin-left: 12px;\n  }\n"]), r.Button),
      bn = a.div.withConfig({
    displayName: "ToolbarPlaceholder",
    componentId: "sc-1nu20pz"
  })(L = L || c(["\n  position: relative;\n  opacity: 0;\n  display: block;\n  width: 100%;\n  height: var(--tina-toolbar-height);\n"], ["\n  position: relative;\n  opacity: 0;\n  display: block;\n  width: 100%;\n  height: var(--tina-toolbar-height);\n"])),
      vn = a.span.withConfig({
    displayName: "StatusLight",
    componentId: "sc-fzcczh"
  })(R = R || c(["\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 8px;\n  margin-top: -1px;\n  background-color: #3cad3a;\n  border: 1px solid #249a21;\n  margin-right: 5px;\n  opacity: 0.5;\n\n  ", ";\n"], ["\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 8px;\n  margin-top: -1px;\n  background-color: #3cad3a;\n  border: 1px solid #249a21;\n  margin-right: 5px;\n  opacity: 0.5;\n\n  ", ";\n"]), function (n) {
    return n.warning && e.css(_ = _ || c(["\n      background-color: #e9d050;\n      border: 1px solid #d3ba38;\n      opacity: 1;\n    "], ["\n      background-color: #e9d050;\n      border: 1px solid #d3ba38;\n      opacity: 1;\n    "]));
  }),
      xn = a.p.withConfig({
    displayName: "StatusMessage",
    componentId: "sc-dricy0"
  })(W = W || c(["\n  font-size: var(--tina-font-size-3);\n  display: flex;\n  align-items: center;\n  color: var(--tina-color-grey-6);\n  padding-right: 4px;\n  line-height: 1.35;\n  margin: 0;\n"], ["\n  font-size: var(--tina-font-size-3);\n  display: flex;\n  align-items: center;\n  color: var(--tina-color-grey-6);\n  padding-right: 4px;\n  line-height: 1.35;\n  margin: 0;\n"])),
      yn = a(r.Button).withConfig({
    displayName: "MenuToggle",
    componentId: "sc-q33kwd"
  })(K = K || c(["\n  position: relative;\n  margin-left: -12px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  outline: none;\n\n  svg {\n    position: relative;\n    transition: fill 85ms ease-out;\n    fill: var(--tina-color-grey-6);\n    margin-left: -4px;\n    width: 28px;\n    height: auto;\n    path {\n      position: relative;\n      transition: transform var(--tina-timing-long) ease-out,\n        opacity var(--tina-timing-long) ease-out,\n        fill var(--tina-timing-short) ease-out;\n      transform-origin: 50% 50%;\n    }\n  }\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-7);\n    }\n  }\n  ", ";\n"], ["\n  position: relative;\n  margin-left: -12px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  outline: none;\n\n  svg {\n    position: relative;\n    transition: fill 85ms ease-out;\n    fill: var(--tina-color-grey-6);\n    margin-left: -4px;\n    width: 28px;\n    height: auto;\n    path {\n      position: relative;\n      transition: transform var(--tina-timing-long) ease-out,\n        opacity var(--tina-timing-long) ease-out,\n        fill var(--tina-timing-short) ease-out;\n      transform-origin: 50% 50%;\n    }\n  }\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-7);\n    }\n  }\n  ", ";\n"]), function (n) {
    return n.open && e.css(H = H || c(["\n      svg {\n        path:first-child {\n          /* Top bar */\n          transform: rotate(45deg) translate3d(0, 0.45rem, 0);\n        }\n        path:nth-child(2) {\n          /* Middle bar */\n          transform: translate3d(-100%, 0, 0);\n          opacity: 0;\n        }\n        path:last-child {\n          /* Bottom Bar */\n          transform: rotate(-45deg) translate3d(0, -0.45rem, 0);\n        }\n      }\n    "], ["\n      svg {\n        path:first-child {\n          /* Top bar */\n          transform: rotate(45deg) translate3d(0, 0.45rem, 0);\n        }\n        path:nth-child(2) {\n          /* Middle bar */\n          transform: translate3d(-100%, 0, 0);\n          opacity: 0;\n        }\n        path:last-child {\n          /* Bottom Bar */\n          transform: rotate(-45deg) translate3d(0, -0.45rem, 0);\n        }\n      }\n    "]));
  }),
      wn = a.div.withConfig({
    displayName: "MenuList",
    componentId: "sc-1d1db49"
  })(U = U || c(["\n  margin: 0 calc(var(--tina-padding-big) * -1) 32px\n    calc(var(--tina-padding-big) * -1);\n  display: block;\n"], ["\n  margin: 0 calc(var(--tina-padding-big) * -1) 32px\n    calc(var(--tina-padding-big) * -1);\n  display: block;\n"])),
      kn = a.div.withConfig({
    displayName: "MenuLink",
    componentId: "sc-g5npod"
  })(V = V || c(["\n  color: var(--tina-color-grey-1);\n  font-size: var(--tina-font-size-4);\n  font-weight: var(--tina-font-weight-regular);\n  padding: var(--tina-padding-big) var(--tina-padding-big)\n    var(--tina-padding-big) 64px;\n  position: relative;\n  cursor: pointer;\n  transition: all var(--tina-timing-short) ease-out;\n  overflow: hidden;\n  &:after {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    border-radius: var(--tina-radius-big);\n    background-color: var(--tina-color-grey-9);\n    z-index: -1;\n    transition: all 150ms ease;\n    transform: translate3d(0, 100%, 0);\n    opacity: 0;\n  }\n  &:hover {\n    color: var(--tina-color-primary-light);\n    &:after {\n      transform: translate3d(0, 0, 0);\n      transition: transform var(--tina-timing-short) ease-out, opacity 0ms;\n      opacity: 1;\n    }\n    svg {\n      fill: var(--tina-color-primary);\n    }\n    & ~ * {\n      &:after {\n        transform: translate3d(0, -100%, 0);\n      }\n    }\n  }\n  svg {\n    position: absolute;\n    left: var(--tina-padding-big);\n    top: 50%;\n    transform: translate3d(0, -50%, 0);\n    width: 36px;\n    height: auto;\n    fill: var(--tina-color-grey-4);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n"], ["\n  color: var(--tina-color-grey-1);\n  font-size: var(--tina-font-size-4);\n  font-weight: var(--tina-font-weight-regular);\n  padding: var(--tina-padding-big) var(--tina-padding-big)\n    var(--tina-padding-big) 64px;\n  position: relative;\n  cursor: pointer;\n  transition: all var(--tina-timing-short) ease-out;\n  overflow: hidden;\n  &:after {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 8px;\n    left: 8px;\n    right: 8px;\n    border-radius: var(--tina-radius-big);\n    background-color: var(--tina-color-grey-9);\n    z-index: -1;\n    transition: all 150ms ease;\n    transform: translate3d(0, 100%, 0);\n    opacity: 0;\n  }\n  &:hover {\n    color: var(--tina-color-primary-light);\n    &:after {\n      transform: translate3d(0, 0, 0);\n      transition: transform var(--tina-timing-short) ease-out, opacity 0ms;\n      opacity: 1;\n    }\n    svg {\n      fill: var(--tina-color-primary);\n    }\n    & ~ * {\n      &:after {\n        transform: translate3d(0, -100%, 0);\n      }\n    }\n  }\n  svg {\n    position: absolute;\n    left: var(--tina-padding-big);\n    top: 50%;\n    transform: translate3d(0, -50%, 0);\n    width: 36px;\n    height: auto;\n    fill: var(--tina-color-grey-4);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n"])),
      En = a.div.withConfig({
    displayName: "MenuWrapper",
    componentId: "sc-yvars7"
  })(G = G || c(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: var(--tina-padding-big);\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding: var(--tina-padding-big);\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"])),
      Cn = a.div.withConfig({
    displayName: "MenuPanel",
    componentId: "sc-1827wkm"
  })(J = J || c(["\n  all: unset;\n  ", "\n  box-sizing: border-box;\n  background: var(--tina-color-grey-8);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: var(--tina-sidebar-width);\n  transform: translate3d(", ", 0, 0);\n  overflow: hidden;\n  padding: var(--tina-padding-big);\n  transition: all var(--tina-timing-long) ease-out;\n  z-index: var(--tina-z-index-2);\n\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"], ["\n  all: unset;\n  ", "\n  box-sizing: border-box;\n  background: var(--tina-color-grey-8);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: var(--tina-sidebar-width);\n  transform: translate3d(", ", 0, 0);\n  overflow: hidden;\n  padding: var(--tina-padding-big);\n  transition: all var(--tina-timing-long) ease-out;\n  z-index: var(--tina-z-index-2);\n\n  ul,\n  li {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n"]), r.tina_reset_styles, function (n) {
    return n.visible ? "0" : "-100%";
  }),
      zn = a(function (n) {
    var e = function (n, e) {
      var t = {};

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
      }

      if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;

        for (i = Object.getOwnPropertySymbols(n); a < i.length; a++) {
          e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[a]) && (t[i[a]] = n[i[a]]);
        }
      }

      return t;
    }(n, []);

    return k.createElement("div", _S({}, e), k.createElement(z.TinaIcon, null));
  }).withConfig({
    displayName: "Watermark",
    componentId: "sc-1y9sh3v"
  })(Q = Q || c(["\n  position: absolute;\n  z-index: -1;\n  bottom: var(--tina-padding-big);\n  left: var(--tina-padding-big);\n  svg {\n    width: 128px;\n    height: 128px;\n    margin: -4px -20px;\n    fill: var(--tina-color-grey-9);\n  }\n"], ["\n  position: absolute;\n  z-index: -1;\n  bottom: var(--tina-padding-big);\n  left: var(--tina-padding-big);\n  svg {\n    width: 128px;\n    height: 128px;\n    margin: -4px -20px;\n    fill: var(--tina-color-grey-9);\n  }\n"]));

  n.Toolbar = function () {
    var n,
        e = E.useCMS(),
        t = e.plugins.getType("toolbar:widget"),
        i = e.plugins.getType("form"),
        a = i.all().length ? i.all()[0] : null,
        r = null == a ? void 0 : a.finalForm.getState(),
        o = function (n, e) {
      var t = k.useState(),
          i = t[0],
          a = t[1];
      return k.useEffect(function () {
        if (n) return n.subscribe(a, e);
      }, [n]), i;
    }(a, {
      pristine: !0,
      submitting: !0
    }),
        l = k.useState(0)[1],
        s = e.plugins.getType("screen");

    E.useSubscribable(s);
    var d = s.all(),
        c = 0 < d.length,
        p = k.useState(null),
        g = p[0],
        m = p[1],
        u = k.useState(!1),
        f = u[0],
        h = u[1];
    E.useSubscribable(i), E.useSubscribable(t);
    var b = (null === (n = e.toolbar) || void 0 === n ? void 0 : n.buttons) || (null == a ? void 0 : a.buttons) || {
      save: "Save",
      reset: "Reset"
    },
        v = a && a.submit,
        x = !a,
        y = x || o && (null == r ? void 0 : r.pristine),
        w = !x && !!(o && (null == r ? void 0 : r.submitting));
    return k.createElement(k.Fragment, null, k.createElement(bn, null), k.createElement(cn, {
      menuIsOpen: f
    }, k.createElement(mn, null, c && k.createElement(yn, {
      onClick: function onClick() {
        return h(!f);
      },
      open: f
    }, k.createElement(z.HamburgerIcon, null)), k.createElement(N, null)), k.createElement(un, null, 1 <= t.all().length && k.createElement(gn, null, t.all().sort(function (n, e) {
      return n.weight - e.weight;
    }).map(function (n) {
      return k.createElement(n.component, _S({
        key: n.name
      }, n.props));
    })), k.createElement(fn, null, k.createElement(dn, {
      dirty: !y
    })), k.createElement(hn, null, k.createElement(an, {
      disabled: x || y,
      onClick: function onClick() {
        a && (a.reset(), l(function (n) {
          return n++;
        }));
      }
    }, k.createElement(z.ResetIcon, null), k.createElement(X, null, b.reset)), k.createElement(pn, {
      primary: !0,
      onClick: v,
      busy: w,
      disabled: x || y
    }, w && k.createElement(I.LoadingDots, null), !w && k.createElement(k.Fragment, null, k.createElement(X, null, b.save))), k.createElement(M, {
      form: a
    })))), c && k.createElement(Cn, {
      visible: f
    }, k.createElement(En, null, k.createElement(wn, null, d.map(function (n) {
      var e = n.Icon;
      return k.createElement(kn, {
        key: n.name,
        value: n.name,
        onClick: function onClick() {
          m(n), h(!1);
        }
      }, k.createElement(e, null), " ", n.name);
    }))), k.createElement(zn, null)), g && k.createElement(C.ScreenPluginModal, {
      screen: g,
      close: function close() {
        return m(null);
      }
    }));
  }, n.ToolbarState = i, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});